export default __webpack_public_path__ + "static/media/Arrowback.ceeb160a.svg";